/**
 * 🎨 Theme Styles - Estilos adicionales de temas
 * @version 1.0.0
 * @description Estilos específicos para cada tema del chat widget
 */

export class ThemeStyles {
  /**
   * 🚀 Obtiene los estilos del tema moderno
   * @returns {string} Estilos CSS del tema moderno
   */
  static getModernThemeStyles() {
    return `
      /* Tema Moderno */
      .modul-assistant-sdk-chat-button {
        background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
        box-shadow: 0 8px 32px rgba(99, 102, 241, 0.4);
        animation: modul-assistant-sdk-modern-pulse 3s infinite;
      }

      .modul-assistant-sdk-chat-button:hover {
        transform: scale(1.1);
        box-shadow: 0 12px 40px rgba(99, 102, 241, 0.5);
        background: linear-gradient(135deg, #7c3aed 0%, #a855f7 100%);
      }

      .modul-assistant-sdk-chat-button.active {
        background: linear-gradient(135deg, #f59e0b 0%, #f97316 100%);
        box-shadow: 0 8px 32px rgba(245, 158, 11, 0.4);
      }

      .modul-assistant-sdk-chat-window {
        box-shadow: 0 25px 60px rgba(0, 0, 0, 0.12);
        border: 1px solid rgba(99, 102, 241, 0.2);
        backdrop-filter: blur(10px);
      }

      .modul-assistant-sdk-chat-header {
        background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      }

      .modul-assistant-sdk-chat-body {
        background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
      }

      .modul-assistant-sdk-chat-message.bot {
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        box-shadow: 0 4px 20px rgba(99, 102, 241, 0.1);
        border: 1px solid rgba(99, 102, 241, 0.1);
      }

      /* Estilos para mensajes de error en tema moderno */
      .modul-assistant-sdk-chat-message.bot.error-message {
        background: linear-gradient(135deg, #fef2f2 0%, #fde2e2 100%);
        border: 1px solid #f87171;
        color: #dc2626;
        box-shadow: 0 4px 20px rgba(248, 113, 113, 0.2);
      }

      .modul-assistant-sdk-chat-message.bot.error-message strong {
        color: #b91c1c;
        font-weight: bold;
      }

      .modul-assistant-sdk-chat-message.bot.error-message small {
        color: #6b7280;
        font-style: italic;
        opacity: 0.8;
      }

      .modul-assistant-sdk-chat-message.bot a {
        color: #6366f1;
        text-decoration-color: #c7d2fe;
      }

      .modul-assistant-sdk-chat-message.bot a:hover {
        color: #4f46e5;
        text-decoration-color: #a5b4fc;
      }

      .modul-assistant-sdk-chat-message.user {
        background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
        box-shadow: 0 4px 20px rgba(99, 102, 241, 0.3);
      }

      .modul-assistant-sdk-chat-input-area {
        border-top: 1px solid rgba(99, 102, 241, 0.1);
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
      }

      .modul-assistant-sdk-chat-input {
        border: 2px solid rgba(99, 102, 241, 0.2);
        background: rgba(255, 255, 255, 0.8);
        border-radius: 12px;
      }

      .modul-assistant-sdk-chat-input:focus {
        border-color: #6366f1;
        background: white;
        box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.1);
      }

      .modul-assistant-sdk-chat-send {
        background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
        border-radius: 12px;
      }

      .modul-assistant-sdk-chat-send:hover {
        background: linear-gradient(135deg, #7c3aed 0%, #a855f7 100%);
        transform: translateY(-2px);
        box-shadow: 0 8px 25px rgba(99, 102, 241, 0.3);
      }

      .modul-assistant-sdk-chat-option {
        border: 2px solid rgba(99, 102, 241, 0.2);
        border-radius: 12px;
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
      }

      .modul-assistant-sdk-chat-option:hover {
        background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
        border-color: #6366f1;
        color: #1e40af;
        transform: translateY(-2px);
        box-shadow: 0 8px 25px rgba(99, 102, 241, 0.2);
      }

      .modul-assistant-sdk-typing-indicator {
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        box-shadow: 0 4px 20px rgba(99, 102, 241, 0.1);
        border: 1px solid rgba(99, 102, 241, 0.1);
      }

      .modul-assistant-sdk-typing-dot {
        background: #6366f1;
      }

      @keyframes modul-assistant-sdk-modern-pulse {
        0% { 
          box-shadow: 0 8px 32px rgba(99, 102, 241, 0.4);
        }
        50% { 
          box-shadow: 0 8px 40px rgba(99, 102, 241, 0.6);
        }
        100% { 
          box-shadow: 0 8px 32px rgba(99, 102, 241, 0.4);
        }
      }
    `;
  }

  /**
   * ⚪ Obtiene los estilos del tema minimal
   * @returns {string} Estilos CSS del tema minimal
   */
  static getMinimalThemeStyles() {
    return `
      /* Tema Minimal */
      .modul-assistant-sdk-chat-button {
        background: #ffffff;
        color: #374151;
        border: 2px solid #e5e7eb;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
      }

      .modul-assistant-sdk-chat-button:hover {
        transform: scale(1.02);
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        background: #f9fafb;
        border-color: #d1d5db;
      }

      .modul-assistant-sdk-chat-button.active {
        background: #f3f4f6;
        color: #111827;
        border-color: #9ca3af;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      }

      .modul-assistant-sdk-chat-window {
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
        border: 1px solid #e5e7eb;
      }

      .modul-assistant-sdk-chat-header {
        background: #ffffff;
        color: #111827;
        border-bottom: 1px solid #e5e7eb;
      }

      .modul-assistant-sdk-chat-header h4 {
        color: #111827;
      }

      .modul-assistant-sdk-chat-close {
        color: #6b7280;
      }

      .modul-assistant-sdk-chat-close:hover {
        background: #f3f4f6;
        color: #374151;
      }

      .modul-assistant-sdk-chat-body {
        background: #ffffff;
      }

      .modul-assistant-sdk-chat-message.bot {
        background: #f9fafb;
        border: 1px solid #e5e7eb;
        box-shadow: none;
      }

      /* Estilos para mensajes de error en tema minimal */
      .modul-assistant-sdk-chat-message.bot.error-message {
        background: #fef2f2;
        border: 1px solid #fca5a5;
        color: #dc2626;
        box-shadow: none;
      }

      .modul-assistant-sdk-chat-message.bot.error-message strong {
        color: #b91c1c;
      }

      .modul-assistant-sdk-chat-message.bot.error-message small {
        color: #6b7280;
      }

      .modul-assistant-sdk-chat-message.bot a {
        color: #4b5563;
        text-decoration-color: #d1d5db;
      }

      .modul-assistant-sdk-chat-message.bot a:hover {
        color: #111827;
        text-decoration-color: #9ca3af;
      }

      .modul-assistant-sdk-chat-message.user {
        background: #111827;
        box-shadow: none;
      }

      .modul-assistant-sdk-chat-input-area {
        border-top: 1px solid #e5e7eb;
        background: #ffffff;
      }

      .modul-assistant-sdk-chat-input {
        border: 1px solid #d1d5db;
        background: #ffffff;
      }

      .modul-assistant-sdk-chat-input:focus {
        border-color: #9ca3af;
        background: #ffffff;
        box-shadow: 0 0 0 1px rgba(156, 163, 175, 0.3);
      }

      .modul-assistant-sdk-chat-send {
        background: #111827;
      }

      .modul-assistant-sdk-chat-send:hover {
        background: #374151;
        transform: none;
        box-shadow: none;
      }

      .modul-assistant-sdk-chat-option {
        border: 1px solid #d1d5db;
        background: #ffffff;
      }

      .modul-assistant-sdk-chat-option:hover {
        background: #f9fafb;
        border-color: #9ca3af;
        color: #111827;
        transform: none;
        box-shadow: none;
      }

      .modul-assistant-sdk-typing-indicator {
        background: #f9fafb;
        border: 1px solid #e5e7eb;
        box-shadow: none;
      }

      .modul-assistant-sdk-typing-dot {
        background: #9ca3af;
      }
    `;
  }

  /**
   * 🌙 Obtiene los estilos del tema dark
   * @returns {string} Estilos CSS del tema dark
   */
  static getDarkThemeStyles() {
    return `
      /* Tema Dark */
      .modul-assistant-sdk-chat-button {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
        border: 1px solid #374151;
      }

      .modul-assistant-sdk-chat-button:hover {
        transform: scale(1.05);
        box-shadow: 0 6px 25px rgba(0, 0, 0, 0.5);
        background: linear-gradient(135deg, #374151 0%, #1f2937 100%);
      }

      .modul-assistant-sdk-chat-button.active {
        background: linear-gradient(135deg, #7c2d12 0%, #dc2626 100%);
        box-shadow: 0 4px 20px rgba(220, 38, 38, 0.4);
      }

      .modul-assistant-sdk-chat-window {
        background: #111827;
        box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
        border: 1px solid #374151;
      }

      .modul-assistant-sdk-chat-header {
        background: linear-gradient(135deg, #000000 0%, #1f2937 100%);
        border-bottom: 1px solid #374151;
      }

      .modul-assistant-sdk-chat-body {
        background: #111827;
      }

      .modul-assistant-sdk-chat-message.bot {
        background: #1f2937;
        color: #e5e7eb;
        border: 1px solid #374151;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
      }

      /* Estilos para mensajes de error en tema dark */
      .modul-assistant-sdk-chat-message.bot.error-message {
        background: #450a0a;
        border: 1px solid #7f1d1d;
        color: #fca5a5;
        box-shadow: 0 2px 8px rgba(127, 29, 29, 0.3);
      }

      .modul-assistant-sdk-chat-message.bot.error-message strong {
        color: #ef4444;
      }

      .modul-assistant-sdk-chat-message.bot.error-message small {
        color: #9ca3af;
      }

      .modul-assistant-sdk-chat-message.bot a {
        color: #60a5fa;
        text-decoration-color: #3b82f6;
      }

      .modul-assistant-sdk-chat-message.bot a:hover {
        color: #93c5fd;
        text-decoration-color: #60a5fa;
      }

      .modul-assistant-sdk-chat-message.user {
        background: linear-gradient(135deg, #1e40af 0%, #1d4ed8 100%);
        box-shadow: 0 2px 8px rgba(30, 64, 175, 0.3);
      }

      .modul-assistant-sdk-chat-input-area {
        background: #1f2937;
        border-top: 1px solid #374151;
      }

      .modul-assistant-sdk-chat-input {
        background: #374151;
        border: 1px solid #4b5563;
        color: #e5e7eb;
      }

      .modul-assistant-sdk-chat-input::placeholder {
        color: #9ca3af;
      }

      .modul-assistant-sdk-chat-input:focus {
        border-color: #6b7280;
        background: #4b5563;
        box-shadow: 0 0 0 3px rgba(107, 114, 128, 0.3);
      }

      .modul-assistant-sdk-chat-send {
        background: linear-gradient(135deg, #1e40af 0%, #1d4ed8 100%);
      }

      .modul-assistant-sdk-chat-send:hover {
        background: linear-gradient(135deg, #2563eb 0%, #3b82f6 100%);
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
      }

      .modul-assistant-sdk-chat-option {
        background: #1f2937;
        color: #e5e7eb;
        border: 1px solid #374151;
      }

      .modul-assistant-sdk-chat-option:hover {
        background: #374151;
        border-color: #4b5563;
        color: #f9fafb;
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
      }

      .modul-assistant-sdk-typing-indicator {
        background: #1f2937;
        border: 1px solid #374151;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
      }

      .modul-assistant-sdk-typing-dot {
        background: #9ca3af;
      }
    `;
  }

  /**
   * 🌈 Obtiene los estilos del tema colorful
   * @returns {string} Estilos CSS del tema colorful
   */
  static getColorfulThemeStyles() {
    return `
      /* Tema Colorful */
      .modul-assistant-sdk-chat-button {
        background: linear-gradient(135deg, #ec4899 0%, #f59e0b 50%, #10b981 100%);
        box-shadow: 0 8px 32px rgba(236, 72, 153, 0.4);
        animation: modul-assistant-sdk-colorful-pulse 2s infinite;
      }

      .modul-assistant-sdk-chat-button:hover {
        transform: scale(1.1) rotate(5deg);
        box-shadow: 0 12px 40px rgba(236, 72, 153, 0.6);
        background: linear-gradient(135deg, #f59e0b 0%, #10b981 50%, #3b82f6 100%);
      }

      .modul-assistant-sdk-chat-button.active {
        background: linear-gradient(135deg, #dc2626 0%, #9333ea 50%, #0ea5e9 100%);
        box-shadow: 0 8px 32px rgba(220, 38, 38, 0.4);
        transform: rotate(-5deg);
      }

      .modul-assistant-sdk-chat-window {
        background: linear-gradient(135deg, #fef7ff 0%, #fff1f2 50%, #f0fdf4 100%);
        box-shadow: 0 25px 60px rgba(236, 72, 153, 0.2);
        border: 2px solid transparent;
        background-clip: padding-box;
      }

      .modul-assistant-sdk-chat-header {
        background: linear-gradient(135deg, #ec4899 0%, #f59e0b 50%, #10b981 100%);
        border-bottom: none;
      }

      .modul-assistant-sdk-chat-body {
        background: transparent;
      }

      .modul-assistant-sdk-chat-message.bot {
        background: linear-gradient(135deg, #ffffff 0%, #fef7ff 100%);
        box-shadow: 0 4px 20px rgba(236, 72, 153, 0.1);
        border: 2px solid transparent;
        background-clip: padding-box;
        position: relative;
      }

      .modul-assistant-sdk-chat-message.bot::before {
        content: '';
        position: absolute;
        top: -2px;
        left: -2px;
        right: -2px;
        bottom: -2px;
        background: linear-gradient(135deg, #ec4899, #f59e0b, #10b981, #3b82f6);
        border-radius: inherit;
        z-index: -1;
        opacity: 0.3;
      }

      /* Estilos para mensajes de error en tema colorful */
      .modul-assistant-sdk-chat-message.bot.error-message {
        background: linear-gradient(135deg, #fef2f2 0%, #fde2e2 100%);
        border: 2px solid #f87171;
        color: #dc2626;
        box-shadow: 0 4px 20px rgba(248, 113, 113, 0.3);
      }

      .modul-assistant-sdk-chat-message.bot.error-message::before {
        background: linear-gradient(135deg, #dc2626, #ef4444, #f87171);
      }

      .modul-assistant-sdk-chat-message.bot.error-message strong {
        color: #b91c1c;
      }

      .modul-assistant-sdk-chat-message.bot.error-message small {
        color: #6b7280;
      }

      .modul-assistant-sdk-chat-message.bot a {
        color: #ec4899;
        text-decoration-color: #f9a8d4;
      }

      .modul-assistant-sdk-chat-message.bot a:hover {
        color: #be185d;
        text-decoration-color: #ec4899;
      }

      .modul-assistant-sdk-chat-message.user {
        background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
        box-shadow: 0 4px 20px rgba(59, 130, 246, 0.3);
      }

      .modul-assistant-sdk-chat-input-area {
        background: linear-gradient(135deg, #ffffff 0%, #fef7ff 100%);
        border-top: 2px solid transparent;
        background-clip: padding-box;
      }

      .modul-assistant-sdk-chat-input {
        border: 2px solid transparent;
        background: linear-gradient(white, white) padding-box, 
                   linear-gradient(135deg, #ec4899, #f59e0b, #10b981) border-box;
        border-radius: 12px;
      }

      .modul-assistant-sdk-chat-input:focus {
        box-shadow: 0 0 0 4px rgba(236, 72, 153, 0.2);
        background: linear-gradient(white, white) padding-box, 
                   linear-gradient(135deg, #be185d, #d97706, #059669) border-box;
      }

      .modul-assistant-sdk-chat-send {
        background: linear-gradient(135deg, #ec4899 0%, #f59e0b 50%, #10b981 100%);
        border-radius: 12px;
      }

      .modul-assistant-sdk-chat-send:hover {
        background: linear-gradient(135deg, #be185d 0%, #d97706 50%, #059669 100%);
        transform: translateY(-2px) scale(1.05);
        box-shadow: 0 8px 25px rgba(236, 72, 153, 0.4);
      }

      .modul-assistant-sdk-chat-option {
        background: linear-gradient(135deg, #ffffff 0%, #fef7ff 100%);
        border: 2px solid transparent;
        background-clip: padding-box;
        border-radius: 12px;
        position: relative;
      }

      .modul-assistant-sdk-chat-option::before {
        content: '';
        position: absolute;
        top: -2px;
        left: -2px;
        right: -2px;
        bottom: -2px;
        background: linear-gradient(135deg, #ec4899, #f59e0b, #10b981);
        border-radius: inherit;
        z-index: -1;
        opacity: 0.5;
      }

      .modul-assistant-sdk-chat-option:hover {
        background: linear-gradient(135deg, #fef7ff 0%, #fff1f2 100%);
        color: #be185d;
        transform: translateY(-2px) scale(1.02);
        box-shadow: 0 8px 25px rgba(236, 72, 153, 0.3);
      }

      .modul-assistant-sdk-typing-indicator {
        background: linear-gradient(135deg, #ffffff 0%, #fef7ff 100%);
        box-shadow: 0 4px 20px rgba(236, 72, 153, 0.1);
        border: 2px solid transparent;
        background-clip: padding-box;
      }

      .modul-assistant-sdk-typing-dot {
        background: linear-gradient(135deg, #ec4899, #f59e0b, #10b981);
        animation: modul-assistant-sdk-colorful-typing 1.4s infinite ease-in-out;
      }

      @keyframes modul-assistant-sdk-colorful-pulse {
        0% { 
          box-shadow: 0 8px 32px rgba(236, 72, 153, 0.4);
          transform: scale(1);
        }
        50% { 
          box-shadow: 0 12px 40px rgba(245, 158, 11, 0.6);
          transform: scale(1.02);
        }
        100% { 
          box-shadow: 0 8px 32px rgba(16, 185, 129, 0.4);
          transform: scale(1);
        }
      }

      @keyframes modul-assistant-sdk-colorful-typing {
        0%, 80%, 100% {
          transform: scale(0.8);
          opacity: 0.5;
          background: #ec4899;
        }
        20% {
          transform: scale(1);
          opacity: 1;
          background: #f59e0b;
        }
        40% {
          transform: scale(1);
          opacity: 1;
          background: #10b981;
        }
        60% {
          transform: scale(1);
          opacity: 1;
          background: #3b82f6;
        }
      }
    `;
  }

  /**
   * ✨ Obtiene los estilos del tema elegant
   * @returns {string} Estilos CSS del tema elegant
   */
  static getElegantThemeStyles() {
    return `
      /* Tema Elegant */
      .modul-assistant-sdk-chat-button {
        background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
        box-shadow: 0 8px 32px rgba(15, 23, 42, 0.4);
        border: 1px solid #94a3b8;
      }

      .modul-assistant-sdk-chat-button:hover {
        transform: scale(1.05);
        box-shadow: 0 12px 40px rgba(15, 23, 42, 0.6);
        background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
        border-color: #cbd5e1;
      }

      .modul-assistant-sdk-chat-button.active {
        background: linear-gradient(135deg, #713f12 0%, #92400e 100%);
        box-shadow: 0 8px 32px rgba(113, 63, 18, 0.4);
        border-color: #d97706;
      }

      .modul-assistant-sdk-chat-window {
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        box-shadow: 0 25px 60px rgba(15, 23, 42, 0.15);
        border: 1px solid #e2e8f0;
        backdrop-filter: blur(10px);
      }

      .modul-assistant-sdk-chat-header {
        background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
        border-bottom: 1px solid #e2e8f0;
        position: relative;
      }

      .modul-assistant-sdk-chat-header::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 1px;
        background: linear-gradient(90deg, transparent, #94a3b8, transparent);
      }

      .modul-assistant-sdk-chat-body {
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
      }

      .modul-assistant-sdk-chat-message.bot {
        background: linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%);
        box-shadow: 0 4px 20px rgba(15, 23, 42, 0.08);
        border: 1px solid #e2e8f0;
        position: relative;
      }

      .modul-assistant-sdk-chat-message.bot::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 3px;
        background: linear-gradient(135deg, #0f172a 0%, #334155 100%);
        border-radius: 2px 0 0 2px;
      }

      /* Estilos para mensajes de error en tema elegant */
      .modul-assistant-sdk-chat-message.bot.error-message {
        background: linear-gradient(135deg, #fef2f2 0%, #fde2e2 100%);
        border: 1px solid #fca5a5;
        color: #dc2626;
        box-shadow: 0 4px 20px rgba(220, 38, 38, 0.08);
      }

      .modul-assistant-sdk-chat-message.bot.error-message::before {
        background: linear-gradient(135deg, #dc2626 0%, #ef4444 100%);
      }

      .modul-assistant-sdk-chat-message.bot.error-message strong {
        color: #b91c1c;
      }

      .modul-assistant-sdk-chat-message.bot.error-message small {
        color: #64748b;
      }

      .modul-assistant-sdk-chat-message.bot a {
        color: #0f172a;
        text-decoration-color: #94a3b8;
        font-weight: 500;
      }

      .modul-assistant-sdk-chat-message.bot a:hover {
        color: #1e293b;
        text-decoration-color: #64748b;
      }

      .modul-assistant-sdk-chat-message.user {
        background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
        box-shadow: 0 4px 20px rgba(15, 23, 42, 0.2);
        position: relative;
      }

      .modul-assistant-sdk-chat-message.user::after {
        content: '';
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        width: 3px;
        background: linear-gradient(135deg, #94a3b8 0%, #cbd5e1 100%);
        border-radius: 0 2px 2px 0;
      }

      .modul-assistant-sdk-chat-input-area {
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        border-top: 1px solid #e2e8f0;
        position: relative;
      }

      .modul-assistant-sdk-chat-input-area::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 1px;
        background: linear-gradient(90deg, transparent, #94a3b8, transparent);
      }

      .modul-assistant-sdk-chat-input {
        border: 1px solid #e2e8f0;
        background: #ffffff;
        border-radius: 8px;
        transition: all 0.3s ease;
      }

      .modul-assistant-sdk-chat-input:focus {
        border-color: #94a3b8;
        background: #ffffff;
        box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.1);
      }

      .modul-assistant-sdk-chat-send {
        background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
        border-radius: 8px;
      }

      .modul-assistant-sdk-chat-send:hover {
        background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(15, 23, 42, 0.3);
      }

      .modul-assistant-sdk-chat-option {
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        border: 1px solid #e2e8f0;
        border-radius: 8px;
        transition: all 0.3s ease;
        position: relative;
      }

      .modul-assistant-sdk-chat-option::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 3px;
        background: linear-gradient(135deg, #0f172a 0%, #334155 100%);
        border-radius: 2px 0 0 2px;
        opacity: 0;
        transition: opacity 0.3s ease;
      }

      .modul-assistant-sdk-chat-option:hover {
        background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        border-color: #94a3b8;
        color: #0f172a;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(15, 23, 42, 0.1);
      }

      .modul-assistant-sdk-chat-option:hover::before {
        opacity: 1;
      }

      .modul-assistant-sdk-typing-indicator {
        background: linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%);
        box-shadow: 0 4px 20px rgba(15, 23, 42, 0.08);
        border: 1px solid #e2e8f0;
      }

      .modul-assistant-sdk-typing-dot {
        background: #94a3b8;
      }
    `;
  }
}
